<template>
  <div>
    <div class="col-xs-12 col-sm-3 col-md-3" v-if="me">

      <ul class="lk_left_menu">
        <li class="lk_left_menu__header">
          <a href="#" :class="{selected: selected === 'budget'}" @click="setSelected('budget', $event)">
            <span class="lk_left_menu__head-text">Ваш счет:</span><br>
            <span v-if="me">{{me.budget}} Р</span>
          </a>
        </li>

        <li></li>
        <li><a href="#" :class="{selected: selected === 'profile'}" @click="setSelected('profile', $event)">Профиль</a>
        </li>
        <li><a href="/personal/history/">Мои заказы</a></li>
        <li><a href="#" :class="{selected: selected === 'bill'}" @click="setSelected('bill', $event)">Выставить счет
          aitech-service.ru</a></li>
        <li v-if="ownBillUsersIds.includes(parseInt(me.id))"><a href="/personal/service/index_dns.php">Выставить
          собственный счет</a></li>
        <li><a href="#" :class="{selected: selected === 'documents'}" @click="setSelected('documents', $event)">Закрывающие
          документы</a></li>
        <li><a href="#" :class="{selected: selected === 'return'}" @click="setSelected('return', $event)">Обращение</a>
        </li>
        <li><a href="#" :class="{selected: selected === 'subscribe'}"
               @click="setSelected('subscribe', $event)">Подписка на рассылку</a></li>
        <li><a href="/personal/favorit">Избранное</a></li>
        <li><a href="#" :class="{selected: selected === 'price-list'}" @click="setSelected('price-list', $event)">Прайсы - Выгрузки</a>
        </li>
      </ul>
    </div>
    <div class="col-xs-12 col-sm-9 col-md-9">
      <budget v-if="selected === 'budget'"></budget>
      <PersonalProfile v-else-if="selected === 'profile'"></PersonalProfile>
      <div v-else-if="selected === 'orders'">Мои заказы</div>
      <bill v-else-if="selected === 'bill'"></bill>
      <close-docs v-else-if="selected === 'documents'">Закрывающие документы</close-docs>
      <Return v-else-if="selected === 'return'">Обращение</Return>
      <subscribe v-else-if="selected === 'subscribe'"></subscribe>
      <div v-else-if="selected === 'wishlist'">Избранное</div>
      <price-list v-else-if="selected === 'price-list'"></price-list>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Return from './Return'
  import PersonalProfile from './PersonalProfile'
  import Orders from './Orders'
  import Budget from './Budget'
  import Bill from './Bill'
  import Subscribe from './Subscribe'
  import CloseDocs from './CloseDocs'
  import PriceList from './PriceList'

  export default {
    name: 'Account',
    components: {CloseDocs, Subscribe, Bill, Budget, Orders, PersonalProfile, Return, PriceList},
    created () {
      this.$store.dispatch('user/fetchMe')
      this.$store.dispatch('user/fetchManager')
      this.selected = this.$route.query.selected || 'profile'
    },
    mounted () {
      console.log(this)
    },
    computed: {
      ...mapGetters('user', [
        'me',
        'manager'
      ]),
      now () {
        let today = new Date()
        let dd = today.getDate()
        let mm = today.getMonth() + 1

        let yyyy = today.getFullYear()
        if (dd < 10) {
          dd = '0' + dd
        }
        if (mm < 10) {
          mm = '0' + mm
        }
        return dd + '.' + mm + '.' + yyyy
      }
    },
    data () {
      return {
        selected: 'profile',
        ownBillUsersIds: [1, 2681, 850]
      }
    },
    methods: {
      setSelected (selected, $event) {
        $event.preventDefault()
        this.selected = selected
      }
    }

  }
</script>

<style lang="scss" scoped>
  /* Left menu*/

  .lk_left_menu {
    list-style: none;
    padding: 0;
    margin: 0 0 8px;
    position: relative;
    /*IE bug*/
    border: 1px solid #e5e5e5;
    border-radius: 10px;
    &__header {
      padding: 30px 20px 20px 20px;
      background-color: #e5e5e5;
      span {
        font-size: 16px;
        font-weight: bold;
        &.lk_left_menu__head-text {
          color: #9ea5ae;
          font-weight: normal;
        }
      }

    }
    li {
      padding: 10px 16px;
      a {
        font-size: 14px;
        color: rgb(62, 62, 62);
        text-align: left;
        text-decoration: none;
        transition: all .55s ease;
        &:hover {
          color: #6AD2AA;
        }
        &.selected {
          &:link, &:visited, &:active, &:hover {
            color: #6AD2AA;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Personal/Account.vue